// Only the server-issued reconnect credential persists. Screens and drafts stay tab-local.
const KEY = 'kelimoSessionV194';
function nativeSession() { return typeof window !== 'undefined' && window.Capacitor?.isNativePlatform?.() ? window.KelimoNative?.session : null; }
function isNative() { return typeof window !== 'undefined' && window.Capacitor?.isNativePlatform?.(); }
function hydratePersistentSession(session, local) {
  if (isNative()) return; // Hydrated before App loads; never read native plaintext.
  try {
    if (session.getItem('username') && session.getItem('reconnectToken')) return;
    const saved = JSON.parse(local.getItem(KEY) || 'null');
    if (saved && typeof saved.username === 'string' && /^[a-f0-9]{64}$/.test(saved.token)) {
      session.setItem('username', saved.username);
      session.setItem('reconnectToken', saved.token);
      session.setItem('currentScreen', 'start');
    }
  } catch (_) { /* Private browsing can disable persistent storage. */ }
}
function persistSession(session, local) {
  if (isNative()) return nativeSession()?.persist() ?? false;
  try {
    const username = session.getItem('username'), token = session.getItem('reconnectToken');
    if (username && token) local.setItem(KEY, JSON.stringify({ username, token }));
  } catch (_) { return false; }
  return true;
}
function forgetSession(session, local) {
  if (isNative()) { nativeSession()?.forget(); return; }
  try {
    const saved = JSON.parse(local.getItem(KEY) || 'null');
    if (!saved || saved.token === session.getItem('reconnectToken')) local.removeItem(KEY);
  } catch (_) { /* Continue clearing the visible account. */ }
}
module.exports = { KEY, hydratePersistentSession, persistSession, forgetSession };
